import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
//import { DefaultIndexDoc } from '@app/graphql';
import { navigationAnimation, mobileBtnAnimation, mainRoutesAnimation } from '@app/animations';
import { ScreenService, DataService, NavigationService } from '@app/data';
import { PlayerService } from '@app/player';
import { CONSTANTS, ParentRoute } from '@app/constants';


@Component({
  selector: 'main-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.less'],
  animations: [navigationAnimation, mobileBtnAnimation, mainRoutesAnimation]
})
export class MainNavComponent {

  public baseUrl = CONSTANTS.baseUrl;
  public routes$: Observable<ParentRoute[]> = this.data.getRoutes$();
  public route$ = this.data.route$;
  public currentTaxonomyPage$ = this.data.currentTaxonomyPage$;
  public showBackButton$ = this.navigation.showBackButton$;
  public hideNav$ = this.navigation.hideNav$;
  public navigationOpen$ = this.navigation.navigationOpen$;
  public player$ = this.player.player$;
  public navPlayer$ = this.player.navPlayer$;
  public navigationState$ = new BehaviorSubject<any>({url: '', state: false});

  constructor(
    //private screenService: ScreenService,
  	private data: DataService,
    private navigation: NavigationService,
    private player: PlayerService
  ) {}

  public getRoute = (navigationOpen: boolean): string => {
    //console.log('MainNavComponent getRoute navigationOpen ', navigationOpen);
    let route = '/navigace';

    if (navigationOpen) {
      //this.buttonActive$.next(true);
      route = this.data.getLastRoute().url;
    }

    //console.log('MainNavComponent getRoute route ', route);
    return route;
  }

  public mouseEvent(route: ParentRoute, state: string): void {
    console.log('MainNavComponent mouseEvent route.url ', route.url);
    console.log('MainNavComponent mouseEvent state ', state);
    this.navigationState$.next({url: route.url, state: state})
  }

}
